import { createFeatureSelector } from '@ngrx/store';
import { CurrencyListState } from './currency-list.reducer';

export const selectCurrencyList = createFeatureSelector<CurrencyListState>('currencyList');
